<template>
  <div>
    <TableView
      :onSearch="getConsultaRisco"
      :tableData="tableData"
      :tableHead="tableHead"
      :pagination="pagination"
      :response="response"
      :loadingTable="loadingTable"
      disableInputSearch
      disableCheckAll
      disabledConfigCell
    />
  </div>
</template>

<script>

import Rest from 'common/rest'
import TableView from 'common/table'

export default {
    name: 'empresa.consulta.exame',
    components:{TableView},
    mixins:[Rest],
    data () {
      return{
        tableHead: [
          {
            key: 'categoria',
            sortable: true,
            label: 'Categoria',
          },
          {
            key: 'risco',
            sortable: true,
            label: 'Risco',
          },
        ],
        tableData: [],
        loadingTable: false,
        pagination:{},
        response:{},
      }
    },
    beforeDestroy(){
			this.tableData = [];
		},
    created(){
    },

    mounted(){
      this.getConsultaRisco();
    },

    computed: {
    },

    methods:{

      onEdit(data){

      },

      getConsultaRisco(search,page,pagination){

        this.loadingTable = true;
        this.response = {};

        this.get('consulta/externa/risco/'+this.$route.params.consulta,{search:search,page:page,pagination:pagination}).then((result) =>{
          result = result[0];

          this.loadingTable = false;
          this.response = result;

          var data = [], tableData = [], pagination = {};

          if(result.status == 200){
            
            data = result.data.data;
 
            for (var i = 0; i < data.length; i++) {

              var item = {
                id: data[i].id,
                risco: (data[i].risco ? data[i].risco.nome : data[i].nome),
                categoria: (data[i].risco && data[i].risco.categoria ? data[i].risco.categoria.categoria : (data[i].categoria ? data[i].categoria.categoria : null)),
                _data: data[i],
                buttons : []
              };

              tableData.push(item);
            }

            pagination = result.data;
          }

          this.tableData = tableData;
          this.pagination = pagination;
        });
      }
    }
}
</script>
</style>



// WEBPACK FOOTER //
// index.vue?5637e234